export default function toggleArrayElement(array, element) {
  return array.includes(element) ? array.filter((e) => e !== element) : [...array, element];
}
